import { INodeAction } from "../../../../UI.Controls/Actions/INodeAction";
import { DropDownMenu } from "../../../../UI.Controls/DropDownMenu/DropDownMenu";
import { createElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Icon, MenuTypes } from "../../FormUI/FormUI";
import { NodeAction, NodeActionType } from "./NodeAction";
import { DesktopToolbarButton } from "./ToolbarButton";
import { XGAction } from "./XGAction";

export class ToolbarMenuButton extends DesktopToolbarButton {
    //#region Fields
    public popupMenu: DropDownMenu;
    public loosingFocus: boolean = false;

    private _firstOpen = true;
    //#endregion Fields

    //#region Constructors
    constructor(icon: Icon | string, menuType: MenuTypes, action: NodeAction, classes?: string[]) {
        super(icon, menuType, action, classes);
        //this.Element = element;

        this.popupMenu = new DropDownMenu();
        this.element.appendChild(createElement({ type: "span", classes: ["btn-dropdown-icon", "icon", "ui-triangle-bottom"] }));
    }
    //#endregion Constructors

    /**
     * Vytvoreni instance PopupMenu
     * @param _actions akce k danemu tlacitku
     */
    public createPopupMenu(_callingEvent: Event, _actions: XGAction[]): void {
        // Prázdná metoda
    }

    public initializeItems(): void {
        this._firstOpen = false;
        this.popupMenu.nodeAction = this.action as NodeAction;

        if (this.action instanceof INodeAction && this.action.parentAction instanceof NodeAction) {
            ((this.action.parentAction as NodeAction).toolbarButton as ToolbarMenuButton).closeSubMenuAndSetNew(this);
        }
    }

    /**
     * Kliknuti mysi na nodeAction
     */
    private _onClick(e: MouseEvent): void {
        if (this.element.classList.contains("Disabled"))
            return;

        if (this._firstOpen)
            this.initializeItems();

        if (!this.popupMenu.isVisible()) {
            this.popupMenu.show(this.element, e);
        } else {
            this.popupMenu.closeAll();
        }

        this.element.tabIndex = 1; //udajne je potreba kvuli blur/focusout a focus//tomu aby to bylo focusable mit nastaven tabindex
        if (this.visibilityChanged)
            this.visibilityChanged.trigger(this, this.popupMenu.isVisible());
    }

    private _openedSubMenu: ToolbarMenuButton;

    /**
     * Skryje menu a soucasne subMenu, ktere je z nej otevreno
     */
    public closeMenu(): void {
        this.popupMenu.closeAll();
        if (this._openedSubMenu)
            this._openedSubMenu.closeMenu();
    }

    /**
     * Zavre otevrene subMenu a pripadne si ulozi nove otevrene subMenu
     * @param subMenu - nove otevrene submenu
     */
    public closeSubMenuAndSetNew(subMenu?: ToolbarMenuButton): void {
        if (this._openedSubMenu)
            this._openedSubMenu.closeMenu();
        if (subMenu)
            this._openedSubMenu = subMenu;
    }

    /**
     * Nastaveni eventu
     */
    protected override _setListeners(): void {
        if ((this.action as NodeAction).nodeActionType == NodeActionType.naNode && this._menuType == 2) { //pokud ma masterNode => zobrazuje se submenu pri mouseover
            this._events.addListener(this.element, "mouseover", e => this._onClick(e));
            this._events.addListener(this.element, "click", () => {
                if (this.action instanceof INodeAction)
                    ((this.action.parentAction as NodeAction).toolbarButton as ToolbarMenuButton).loosingFocus = false;
            });
        } else //pokud nema masterNode, tak je akce primo v Toolbaru a zobrazuje se az pri kliku na akci
            this._events.addListener(this.element, "click", e => this._onClick(e));
    }
}
